// @flow
import React from 'react';

interface Props {
  fill?: string;
}

const RatingStar = ({ fill }: Props) => {
  return (
    <svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.2239 11.4378C31.024 10.8177 30.4746 10.3792 29.824 10.3191L20.989 9.51636L17.4955 1.33889C17.2382 0.740245 16.6515 0.353516 15.9996 0.353516C15.3475 0.353516 14.7608 0.741465 14.5035 1.34158L11.0103 9.51782L2.17385 10.3203C1.52466 10.3792 0.975328 10.8177 0.775127 11.4378C0.57395 12.0579 0.760479 12.7364 1.25121 13.1659L7.9301 19.022L5.96057 27.6955C5.81676 28.333 6.06457 28.9915 6.59413 29.3755C6.87661 29.5835 7.21133 29.6875 7.54606 29.6875C7.83537 29.6875 8.12347 29.6104 8.3808 29.4556L15.9996 24.8996L23.617 29.4544C24.1744 29.7889 24.8771 29.7596 25.4052 29.377C25.9345 28.9929 26.1825 28.3342 26.0385 27.6968L24.0692 19.0234L30.7481 13.1671C31.2386 12.7379 31.4253 12.0591 31.2239 11.4378Z"
        fill={fill || '#DADCE0'}
      />
    </svg>
  );
};

export default RatingStar;
